
import batchmultMain from '@/components/detection/batchmultMain'
import freeDetect from '@/mixins/freeDetect'

export default {
  components: {
    batchmultMain
  },
  mixins: [freeDetect],
  watch:{
    urlList:function (newValue){
      let arr = newValue.split(/\r*\n/)
      let newarr = arr.filter((item, index, self) => {
        return item.trim() !== '' && self.indexOf(item) === index
      })
      this.url_array = newarr
    }
  },
  data () {
    return {
      init:false,
      reset:true,
      dialogVisible:false,
      url_array:[],
      urlList:'',
      userToken:localStorage.getItem('key') ? localStorage.getItem('key') : '', // 用户token,
      nodeList:[],
      ApiList:[],
      jiance_type:[],
      jiance_node:'',
      search_btn_txt:'开始检测',
      start_btn_loading:false,
    }
  },
  created () {
    this.getNodeList() // 获取节点列表
    this.getApiList() //获取api列表
  },
  methods: {
    clear(){
      location.reload()
    },
    async getNodeList () {
      try {
        const { data } = await this.$http.post('/apiinterface/nodelist')
        if (data.status == 'success') {
          this.nodeList = data.data
        } else {
          this.$message.error(data.msg)
        }
      } catch (err) {
        this.$message.error('网络异常,请稍后再试')
      }
    },
    async getApiList () {
      try {
        const { data } = await this.$http.post('/apiinterface/apilist')
        if (data.status == 'success') {
          this.ApiList = data.data
        } else {
          this.$message.error(data.msg)
        }
      } catch (err) {
        this.$message.error('网络异常,请稍后重试')
      }
    },
    creatOk(){
      this.init ? this.main() : this.init = true
    },
    //核心检测代码
    main(){
      this.search_btn_txt='检测中...'
      this.start_btn_loading = true
      let form = {
        url:this.url_array,
        type:this.jiance_type,
        usertoken:this.userToken,
        ctoken:this.ctoken,
      }
      this.$refs.startTable.start(form,this.ApiList)
    },
    //开始检测
    startSearch(){
      if (this.urlList.length == 0) return this.$message.error('查询域名不能为空')
      if (this.jiance_type.length == 0) return this.$message.error('请选择查询条件')
      this.userToken.trim() == '' ? this.scrollyz() : this.search()
    },
    search(){
      this.reset = false
      this.$nextTick(()=> this.reset=true)
    },
    isOk(){
      this.search_btn_txt='开始检测'
      this.start_btn_loading = false
    }
  }
}
